import React from "react";
import logo from "../assets/images/logo.png";
import left from "../assets/images/left.png";
import { useNavigate } from "react-router-dom";

function HeaderLeft(props) {
  const navigate = useNavigate();
  const strockScreen = localStorage.getItem("screen");
  let userData = localStorage.getItem("user");
  userData = JSON.parse(userData);  

  const handlePageNavigation = () => {
    if (strockScreen) {
      const routeArr = JSON.parse(strockScreen);
      if (routeArr[0] === "applicant/profile" && routeArr[1] !== "null") {
        navigate(`/applicant/profile/${routeArr[1]}`);
      } else {
        navigate("/welcomePersonalInfo");
      }
    } else if (userData.data.is_approved === 1) {
      navigate("/available");
    } else {
      navigate("/welcomePersonalInfo");
    }
  }

  return (
    <>
      <div class="login_logo  mb_40">
        <button
          style={{
            backgroundColor: "white",
            borderWidth: 0,
          }}
          onClick={() => navigate(-1)}
        >
          <img src={left} alt="" />{" "}
        </button>

        <img src={logo} alt="" style={{cursor:"pointer"}} onClick={() => handlePageNavigation()}/>
      </div>
    </>
  );
}

export default HeaderLeft;
